// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type LogsForBuildQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  buildId: Types.Scalars['UUID'];
  offset?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type LogsForBuildQuery = (
  { __typename?: 'Query' }
  & { logsForBuild?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'Log' }
    & Pick<Types.Log, 'id' | 'message' | 'timestamp' | 'sourceStream' | 'command'>
  )>>> }
);

export type BuildLogCreatedSubscriptionVariables = Types.Exact<{
  buildId: Types.Scalars['UUID'];
}>;


export type BuildLogCreatedSubscription = (
  { __typename?: 'Subscription' }
  & { buildLogCreated?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'Log' }
    & Pick<Types.Log, 'id' | 'message' | 'timestamp' | 'sourceStream' | 'command'>
  )>>> }
);


export const LogsForBuildDocument = gql`
    query LogsForBuild($siteId: UUID!, $buildId: UUID!, $offset: Int) {
  logsForBuild(siteId: $siteId, buildId: $buildId, offset: $offset) @connection(key: "buildRawLogs", filter: ["buildId"]) {
    id
    message
    timestamp
    sourceStream
    command
  }
}
    `;

/**
 * __useLogsForBuildQuery__
 *
 * To run a query within a React component, call `useLogsForBuildQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogsForBuildQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogsForBuildQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      buildId: // value for 'buildId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useLogsForBuildQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LogsForBuildQuery, LogsForBuildQueryVariables>) {
        return ApolloReactHooks.useQuery<LogsForBuildQuery, LogsForBuildQueryVariables>(LogsForBuildDocument, baseOptions);
      }
export function useLogsForBuildLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LogsForBuildQuery, LogsForBuildQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LogsForBuildQuery, LogsForBuildQueryVariables>(LogsForBuildDocument, baseOptions);
        }
export type LogsForBuildQueryHookResult = ReturnType<typeof useLogsForBuildQuery>;
export type LogsForBuildLazyQueryHookResult = ReturnType<typeof useLogsForBuildLazyQuery>;
export type LogsForBuildQueryResult = ApolloReactCommon.QueryResult<LogsForBuildQuery, LogsForBuildQueryVariables>;
export const BuildLogCreatedDocument = gql`
    subscription BuildLogCreated($buildId: UUID!) {
  buildLogCreated(buildId: $buildId) {
    id
    message
    timestamp
    sourceStream
    command
  }
}
    `;

/**
 * __useBuildLogCreatedSubscription__
 *
 * To run a query within a React component, call `useBuildLogCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBuildLogCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildLogCreatedSubscription({
 *   variables: {
 *      buildId: // value for 'buildId'
 *   },
 * });
 */
export function useBuildLogCreatedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<BuildLogCreatedSubscription, BuildLogCreatedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<BuildLogCreatedSubscription, BuildLogCreatedSubscriptionVariables>(BuildLogCreatedDocument, baseOptions);
      }
export type BuildLogCreatedSubscriptionHookResult = ReturnType<typeof useBuildLogCreatedSubscription>;
export type BuildLogCreatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<BuildLogCreatedSubscription>;
